// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.module.css - Complete rewrite with overlap fixes */

.Footer_footer__rVQKD {
    display: flex;
    justify-content: center;
    margin-top: 80px; /* Space before footer */
    clear: both; /* Clear any floated elements */
    position: relative;
    z-index: 10;
}

.Footer_parentContainer__hGSWY {
    width: 100%;
}

.Footer_mainCContainer__cToTA {
    padding: 0 60px;
    background-color: #fffae3;
}

.Footer_firstFooter__ZcVwZ {
    padding-top: 50px;
    padding-bottom: 40px;
}

.Footer_footerContent__uSE\\+e {
    display: flex;
    gap: 10px;
}

.Footer_logo__upXJN {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
}

.Footer_logo__upXJN img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.Footer_footerRight__0Qsm1 {
    flex: 0.35 1;
}

.Footer_footerTextRight__-tAuj {
    color: #333;
    line-height: 1.6;
}

.Footer_footerTextRight__-tAuj p {
    margin: 0;
    font-size: 14px;
    text-align: justify;
}

.Footer_footerMid__tk\\+Mm {
    flex: 0.3 1;
    display: flex;
    gap: 20px;
    text-align: center;
}

.Footer_footerLeft__oj-52 {
    flex: 0.35 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.Footer_footerLeft__oj-52 h3 {
    font-size: 16px;
    color: #015933;
    margin-bottom: 20px;
}

.Footer_mid__LFSI\\+ {
    flex: 1 1;
}

.Footer_mid__LFSI\\+ h3 {
    font-size: 15px;
    color: #015933;
    margin-bottom: 20px;
}

.Footer_linkContainer__NwVUd {
    display: flex;
    gap: 20px;
    justify-content: center;
}

.Footer_linkContainer__NwVUd .Footer_links__KQfMs {
    list-style: none;
    margin: 0;
    padding: 0;
}

.Footer_linkContainer__NwVUd .Footer_links__KQfMs li {
    padding: 8px 5px;
}

.Footer_linkContainer__NwVUd .Footer_links__KQfMs li a {
    text-decoration: none;
    color: #333;
    font-size: 14px;
    transition: color 0.3s ease;
}

.Footer_linkContainer__NwVUd .Footer_links__KQfMs li a:hover {
    color: #015933;
}

.Footer_socialMedia__a7MLa {
    display: flex;
    gap: 15px;
}

.Footer_socials__Slywi {
    height: 80px;
    width: 80px;
    border: 2px solid #015933;
    border-radius: 16px;
    overflow: hidden;
    transition: transform 0.3s ease;
}

.Footer_socials__Slywi:hover {
    transform: translateY(-5px);
}

.Footer_socials__Slywi img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.Footer_miniFooter__YxVNw {
    background-color: #015933;
    padding: 15px 5px;
    display: flex;
    justify-content: center;
}

.Footer_contMiniFooter__yxQnz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
}

.Footer_miniRight__UGWg6 span {
    color: white;
    font-size: 14px;
}

.Footer_miniFooterIcon__m1Vtv {
    display: flex;
    gap: 10px;
}

.Footer_miniFooterIcon__m1Vtv a {
    padding: 5px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.Footer_miniFooterIcon__m1Vtv a:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.Footer_miniFooterIcon__m1Vtv a img {
    width: 30px;
    height: 20px;
    object-fit: contain;
}

/* Global styles to prevent overlapping */
body {
    margin: 0;
    padding: 0;
    position: relative;
}

.main-content {
    margin-bottom: 120px; /* Space for footer */
}

.page-section {
    margin-bottom: 60px;
    padding-bottom: 30px;
}

/* Container breakpoints */
@media (min-width: 576px) {
    .Footer_container__S86ZI, .Footer_containerSm__ltCVV {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .Footer_container__S86ZI, .Footer_containerMd__J994i {
        max-width: 720px;
    }
}

@media (min-width: 992px) {
    .Footer_container__S86ZI, .Footer_containerLg__C3W6- {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .Footer_container__S86ZI, .Footer_containerXl__o1Jd1 {
        max-width: 1140px;
    }
}

@media (min-width: 1400px) {
    .Footer_container__S86ZI, .Footer_containerXxl__azNn3 {
        max-width: 1320px;
    }
}

@media (min-width: 1600px) {
    .Footer_container__S86ZI, .Footer_containerXxxl__jIANh {
        max-width: 1500px;
    }
}

@media (min-width: 1920px) {
    .Footer_container__S86ZI, .Footer_container4k__8HwWB {
        max-width: 1800px;
    }
}

/* Desktop and Large screens */
@media (min-width: 1025px) {
    .Footer_footer__rVQKD {
        margin-top: 100px;
    }
    
    .main-content {
        margin-bottom: 150px;
    }
}

/* Large tablets and small desktops */
@media (max-width: 1024px) {
    .Footer_mainCContainer__cToTA {
        padding: 0 40px;
    }
    
    .Footer_footerMid__tk\\+Mm {
        gap: 15px;
    }
    
    .Footer_socialMedia__a7MLa {
        gap: 10px;
    }
    
    .Footer_socials__Slywi {
        height: 70px;
        width: 70px;
    }
    
    .Footer_footer__rVQKD {
        margin-top: 100px;
    }
    
    .main-content {
        margin-bottom: 140px;
    }
}

/* Tablets */
@media (max-width: 768px) {
    .Footer_mainCContainer__cToTA {
        padding: 0 30px;
    }
    
    .Footer_firstFooter__ZcVwZ {
        padding-top: 30px;
        padding-bottom: 30px;
    }
    
    .Footer_footerContent__uSE\\+e {
        flex-direction: column;
        gap: 30px;
    }
    
    .Footer_footerRight__0Qsm1 {
        flex: none;
        text-align: center;
    }
    
    .Footer_footerMid__tk\\+Mm {
        flex: none;
        justify-content: center;
        gap: 40px;
    }
    
    .Footer_footerLeft__oj-52 {
        flex: none;
        align-items: center;
        text-align: center;
    }
    
    .Footer_socialMedia__a7MLa {
        justify-content: center;
    }
    
    .Footer_contMiniFooter__yxQnz {
        flex-direction: column;
        gap: 15px;
        text-align: center;
    }
    
    .Footer_miniFooterIcon__m1Vtv {
        justify-content: center;
    }
    
    /* Mobile specific overlap fixes */
    .Footer_footer__rVQKD {
        margin-top: 120px;
        position: relative;
        z-index: 100;
    }
    
    body {
        padding-bottom: 50px;
    }
    
    .main-content {
        margin-bottom: 160px;
        padding-bottom: 40px;
    }
    
    .page-section {
        margin-bottom: 80px;
        padding-bottom: 40px;
    }
    
    /* Ensure no fixed positioning conflicts */
    .page-section:last-of-type {
        margin-bottom: 180px !important;
        padding-bottom: 60px !important;
    }
}

/* Small tablets */
@media (max-width: 640px) {
    .Footer_mainCContainer__cToTA {
        padding: 0 20px;
    }
    
    .Footer_footerMid__tk\\+Mm {
        flex-direction: column;
        gap: 20px;
    }
    
    .Footer_linkContainer__NwVUd {
        gap: 10px;
    }
    
    .Footer_socialMedia__a7MLa {
        gap: 8px;
    }
    
    .Footer_socials__Slywi {
        height: 60px;
        width: 60px;
    }
    
    .Footer_miniFooterIcon__m1Vtv {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .Footer_miniFooterIcon__m1Vtv a img {
        width: 25px;
        height: 18px;
    }
    
    .Footer_footer__rVQKD {
        margin-top: 140px;
    }
    
    .main-content {
        margin-bottom: 180px;
        padding-bottom: 50px;
    }
}

/* Mobile phones */
@media (max-width: 480px) {
    .Footer_mainCContainer__cToTA {
        padding: 0 15px;
    }
    
    .Footer_firstFooter__ZcVwZ {
        padding-top: 20px;
        padding-bottom: 20px;
    }
    
    .Footer_footerContent__uSE\\+e {
        gap: 20px;
    }
    
    .Footer_logo__upXJN {
        width: 40px;
        height: 40px;
        margin: 0 auto 15px;
    }
    
    .Footer_footerTextRight__-tAuj p {
        font-size: 12px;
    }
    
    .Footer_mid__LFSI\\+ h3 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    
    .Footer_footerLeft__oj-52 h3 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    
    .Footer_linkContainer__NwVUd .Footer_links__KQfMs li {
        padding: 6px 5px;
    }
    
    .Footer_linkContainer__NwVUd .Footer_links__KQfMs li a {
        font-size: 12px;
    }
    
    .Footer_socialMedia__a7MLa {
        gap: 6px;
    }
    
    .Footer_socials__Slywi {
        height: 50px;
        width: 50px;
    }
    
    .Footer_miniFooter__YxVNw {
        padding: 10px 5px;
    }
    
    .Footer_miniRight__UGWg6 span {
        font-size: 12px;
    }
    
    .Footer_miniFooterIcon__m1Vtv a img {
        width: 20px;
        height: 15px;
    }
    
    /* Critical mobile overlap fixes */
    .Footer_footer__rVQKD {
        margin-top: 160px;
        position: relative;
        z-index: 999;
        clear: both;
    }
    
    body {
        padding-bottom: 60px;
    }
    
    .main-content {
        margin-bottom: 200px !important;
        padding-bottom: 60px !important;
    }
    
    .page-section {
        margin-bottom: 100px !important;
        padding-bottom: 50px !important;
    }
    
    .content-wrapper {
        margin-bottom: 180px !important;
    }
    
    /* Fix for sections immediately before footer */
    .section-before-footer {
        margin-bottom: 220px !important;
        padding-bottom: 80px !important;
    }
}

/* Very small screens */
@media (max-width: 320px) {
    .Footer_mainCContainer__cToTA {
        padding: 0 10px;
    }
    
    .Footer_footerMid__tk\\+Mm {
        gap: 15px;
    }
    
    .Footer_linkContainer__NwVUd {
        flex-direction: column;
        gap: 5px;
    }
    
    .Footer_socialMedia__a7MLa {
        flex-wrap: wrap;
        justify-content: center;
        gap: 5px;
    }
    
    .Footer_socials__Slywi {
        height: 45px;
        width: 45px;
    }
    
    .Footer_miniFooterIcon__m1Vtv {
        gap: 5px;
    }
    
    .Footer_footer__rVQKD {
        margin-top: 180px;
    }
    
    .main-content {
        margin-bottom: 220px !important;
        padding-bottom: 70px !important;
    }
}

/* Additional utility classes for preventing overlaps */
.footer-spacer {
    height: 100px;
    clear: both;
}

@media (max-width: 768px) {
    .footer-spacer {
        height: 150px;
    }
}

@media (max-width: 480px) {
    .footer-spacer {
        height: 200px;
    }
}

/* Ensure footer stays at bottom */
.page-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.content-area {
    flex: 1 1;
    padding-bottom: 100px;
}

@media (max-width: 768px) {
    .content-area {
        padding-bottom: 180px;
    }
}

@media (max-width: 480px) {
    .content-area {
        padding-bottom: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer.module.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB,EAAE,wBAAwB;IAC1C,WAAW,EAAE,+BAA+B;IAC5C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAS;IACT,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAU;IACV,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAoB,EAAE,qBAAqB;AAC/C;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,qCAAqC;AACrC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA,kCAAkC;IAClC;QACI,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA,0CAA0C;IAC1C;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;IACxB;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,kCAAkC;IAClC;QACI,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA,+CAA+C;IAC/C;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;AACJ;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ","sourcesContent":["/* Footer.module.css - Complete rewrite with overlap fixes */\r\n\r\n.footer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 80px; /* Space before footer */\r\n    clear: both; /* Clear any floated elements */\r\n    position: relative;\r\n    z-index: 10;\r\n}\r\n\r\n.parentContainer {\r\n    width: 100%;\r\n}\r\n\r\n.mainCContainer {\r\n    padding: 0 60px;\r\n    background-color: #fffae3;\r\n}\r\n\r\n.firstFooter {\r\n    padding-top: 50px;\r\n    padding-bottom: 40px;\r\n}\r\n\r\n.footerContent {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.logo {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.logo img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 8px;\r\n}\r\n\r\n.footerRight {\r\n    flex: 0.35;\r\n}\r\n\r\n.footerTextRight {\r\n    color: #333;\r\n    line-height: 1.6;\r\n}\r\n\r\n.footerTextRight p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n    text-align: justify;\r\n}\r\n\r\n.footerMid {\r\n    flex: 0.3;\r\n    display: flex;\r\n    gap: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.footerLeft {\r\n    flex: 0.35;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n}\r\n\r\n.footerLeft h3 {\r\n    font-size: 16px;\r\n    color: #015933;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.mid {\r\n    flex: 1;\r\n}\r\n\r\n.mid h3 {\r\n    font-size: 15px;\r\n    color: #015933;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.linkContainer {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n}\r\n\r\n.linkContainer .links {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.linkContainer .links li {\r\n    padding: 8px 5px;\r\n}\r\n\r\n.linkContainer .links li a {\r\n    text-decoration: none;\r\n    color: #333;\r\n    font-size: 14px;\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n.linkContainer .links li a:hover {\r\n    color: #015933;\r\n}\r\n\r\n.socialMedia {\r\n    display: flex;\r\n    gap: 15px;\r\n}\r\n\r\n.socials {\r\n    height: 80px;\r\n    width: 80px;\r\n    border: 2px solid #015933;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.socials:hover {\r\n    transform: translateY(-5px);\r\n}\r\n\r\n.socials img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.miniFooter {\r\n    background-color: #015933;\r\n    padding: 15px 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.contMiniFooter {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 90%;\r\n}\r\n\r\n.miniRight span {\r\n    color: white;\r\n    font-size: 14px;\r\n}\r\n\r\n.miniFooterIcon {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.miniFooterIcon a {\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.miniFooterIcon a:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.miniFooterIcon a img {\r\n    width: 30px;\r\n    height: 20px;\r\n    object-fit: contain;\r\n}\r\n\r\n/* Global styles to prevent overlapping */\r\n:global(body) {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n}\r\n\r\n:global(.main-content) {\r\n    margin-bottom: 120px; /* Space for footer */\r\n}\r\n\r\n:global(.page-section) {\r\n    margin-bottom: 60px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n/* Container breakpoints */\r\n@media (min-width: 576px) {\r\n    .container, .containerSm {\r\n        max-width: 540px;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .container, .containerMd {\r\n        max-width: 720px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .container, .containerLg {\r\n        max-width: 960px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container, .containerXl {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container, .containerXxl {\r\n        max-width: 1320px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container, .containerXxxl {\r\n        max-width: 1500px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .container, .container4k {\r\n        max-width: 1800px;\r\n    }\r\n}\r\n\r\n/* Desktop and Large screens */\r\n@media (min-width: 1025px) {\r\n    .footer {\r\n        margin-top: 100px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 150px;\r\n    }\r\n}\r\n\r\n/* Large tablets and small desktops */\r\n@media (max-width: 1024px) {\r\n    .mainCContainer {\r\n        padding: 0 40px;\r\n    }\r\n    \r\n    .footerMid {\r\n        gap: 15px;\r\n    }\r\n    \r\n    .socialMedia {\r\n        gap: 10px;\r\n    }\r\n    \r\n    .socials {\r\n        height: 70px;\r\n        width: 70px;\r\n    }\r\n    \r\n    .footer {\r\n        margin-top: 100px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 140px;\r\n    }\r\n}\r\n\r\n/* Tablets */\r\n@media (max-width: 768px) {\r\n    .mainCContainer {\r\n        padding: 0 30px;\r\n    }\r\n    \r\n    .firstFooter {\r\n        padding-top: 30px;\r\n        padding-bottom: 30px;\r\n    }\r\n    \r\n    .footerContent {\r\n        flex-direction: column;\r\n        gap: 30px;\r\n    }\r\n    \r\n    .footerRight {\r\n        flex: none;\r\n        text-align: center;\r\n    }\r\n    \r\n    .footerMid {\r\n        flex: none;\r\n        justify-content: center;\r\n        gap: 40px;\r\n    }\r\n    \r\n    .footerLeft {\r\n        flex: none;\r\n        align-items: center;\r\n        text-align: center;\r\n    }\r\n    \r\n    .socialMedia {\r\n        justify-content: center;\r\n    }\r\n    \r\n    .contMiniFooter {\r\n        flex-direction: column;\r\n        gap: 15px;\r\n        text-align: center;\r\n    }\r\n    \r\n    .miniFooterIcon {\r\n        justify-content: center;\r\n    }\r\n    \r\n    /* Mobile specific overlap fixes */\r\n    .footer {\r\n        margin-top: 120px;\r\n        position: relative;\r\n        z-index: 100;\r\n    }\r\n    \r\n    :global(body) {\r\n        padding-bottom: 50px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 160px;\r\n        padding-bottom: 40px;\r\n    }\r\n    \r\n    :global(.page-section) {\r\n        margin-bottom: 80px;\r\n        padding-bottom: 40px;\r\n    }\r\n    \r\n    /* Ensure no fixed positioning conflicts */\r\n    :global(.page-section:last-of-type) {\r\n        margin-bottom: 180px !important;\r\n        padding-bottom: 60px !important;\r\n    }\r\n}\r\n\r\n/* Small tablets */\r\n@media (max-width: 640px) {\r\n    .mainCContainer {\r\n        padding: 0 20px;\r\n    }\r\n    \r\n    .footerMid {\r\n        flex-direction: column;\r\n        gap: 20px;\r\n    }\r\n    \r\n    .linkContainer {\r\n        gap: 10px;\r\n    }\r\n    \r\n    .socialMedia {\r\n        gap: 8px;\r\n    }\r\n    \r\n    .socials {\r\n        height: 60px;\r\n        width: 60px;\r\n    }\r\n    \r\n    .miniFooterIcon {\r\n        flex-wrap: wrap;\r\n        gap: 8px;\r\n    }\r\n    \r\n    .miniFooterIcon a img {\r\n        width: 25px;\r\n        height: 18px;\r\n    }\r\n    \r\n    .footer {\r\n        margin-top: 140px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 180px;\r\n        padding-bottom: 50px;\r\n    }\r\n}\r\n\r\n/* Mobile phones */\r\n@media (max-width: 480px) {\r\n    .mainCContainer {\r\n        padding: 0 15px;\r\n    }\r\n    \r\n    .firstFooter {\r\n        padding-top: 20px;\r\n        padding-bottom: 20px;\r\n    }\r\n    \r\n    .footerContent {\r\n        gap: 20px;\r\n    }\r\n    \r\n    .logo {\r\n        width: 40px;\r\n        height: 40px;\r\n        margin: 0 auto 15px;\r\n    }\r\n    \r\n    .footerTextRight p {\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .mid h3 {\r\n        font-size: 14px;\r\n        margin-bottom: 15px;\r\n    }\r\n    \r\n    .footerLeft h3 {\r\n        font-size: 14px;\r\n        margin-bottom: 15px;\r\n    }\r\n    \r\n    .linkContainer .links li {\r\n        padding: 6px 5px;\r\n    }\r\n    \r\n    .linkContainer .links li a {\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .socialMedia {\r\n        gap: 6px;\r\n    }\r\n    \r\n    .socials {\r\n        height: 50px;\r\n        width: 50px;\r\n    }\r\n    \r\n    .miniFooter {\r\n        padding: 10px 5px;\r\n    }\r\n    \r\n    .miniRight span {\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .miniFooterIcon a img {\r\n        width: 20px;\r\n        height: 15px;\r\n    }\r\n    \r\n    /* Critical mobile overlap fixes */\r\n    .footer {\r\n        margin-top: 160px;\r\n        position: relative;\r\n        z-index: 999;\r\n        clear: both;\r\n    }\r\n    \r\n    :global(body) {\r\n        padding-bottom: 60px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 200px !important;\r\n        padding-bottom: 60px !important;\r\n    }\r\n    \r\n    :global(.page-section) {\r\n        margin-bottom: 100px !important;\r\n        padding-bottom: 50px !important;\r\n    }\r\n    \r\n    :global(.content-wrapper) {\r\n        margin-bottom: 180px !important;\r\n    }\r\n    \r\n    /* Fix for sections immediately before footer */\r\n    :global(.section-before-footer) {\r\n        margin-bottom: 220px !important;\r\n        padding-bottom: 80px !important;\r\n    }\r\n}\r\n\r\n/* Very small screens */\r\n@media (max-width: 320px) {\r\n    .mainCContainer {\r\n        padding: 0 10px;\r\n    }\r\n    \r\n    .footerMid {\r\n        gap: 15px;\r\n    }\r\n    \r\n    .linkContainer {\r\n        flex-direction: column;\r\n        gap: 5px;\r\n    }\r\n    \r\n    .socialMedia {\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n        gap: 5px;\r\n    }\r\n    \r\n    .socials {\r\n        height: 45px;\r\n        width: 45px;\r\n    }\r\n    \r\n    .miniFooterIcon {\r\n        gap: 5px;\r\n    }\r\n    \r\n    .footer {\r\n        margin-top: 180px;\r\n    }\r\n    \r\n    :global(.main-content) {\r\n        margin-bottom: 220px !important;\r\n        padding-bottom: 70px !important;\r\n    }\r\n}\r\n\r\n/* Additional utility classes for preventing overlaps */\r\n:global(.footer-spacer) {\r\n    height: 100px;\r\n    clear: both;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    :global(.footer-spacer) {\r\n        height: 150px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    :global(.footer-spacer) {\r\n        height: 200px;\r\n    }\r\n}\r\n\r\n/* Ensure footer stays at bottom */\r\n:global(.page-wrapper) {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n:global(.content-area) {\r\n    flex: 1;\r\n    padding-bottom: 100px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    :global(.content-area) {\r\n        padding-bottom: 180px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    :global(.content-area) {\r\n        padding-bottom: 250px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__rVQKD`,
	"parentContainer": `Footer_parentContainer__hGSWY`,
	"mainCContainer": `Footer_mainCContainer__cToTA`,
	"firstFooter": `Footer_firstFooter__ZcVwZ`,
	"footerContent": `Footer_footerContent__uSE+e`,
	"logo": `Footer_logo__upXJN`,
	"footerRight": `Footer_footerRight__0Qsm1`,
	"footerTextRight": `Footer_footerTextRight__-tAuj`,
	"footerMid": `Footer_footerMid__tk+Mm`,
	"footerLeft": `Footer_footerLeft__oj-52`,
	"mid": `Footer_mid__LFSI+`,
	"linkContainer": `Footer_linkContainer__NwVUd`,
	"links": `Footer_links__KQfMs`,
	"socialMedia": `Footer_socialMedia__a7MLa`,
	"socials": `Footer_socials__Slywi`,
	"miniFooter": `Footer_miniFooter__YxVNw`,
	"contMiniFooter": `Footer_contMiniFooter__yxQnz`,
	"miniRight": `Footer_miniRight__UGWg6`,
	"miniFooterIcon": `Footer_miniFooterIcon__m1Vtv`,
	"container": `Footer_container__S86ZI`,
	"containerSm": `Footer_containerSm__ltCVV`,
	"containerMd": `Footer_containerMd__J994i`,
	"containerLg": `Footer_containerLg__C3W6-`,
	"containerXl": `Footer_containerXl__o1Jd1`,
	"containerXxl": `Footer_containerXxl__azNn3`,
	"containerXxxl": `Footer_containerXxxl__jIANh`,
	"container4k": `Footer_container4k__8HwWB`
};
export default ___CSS_LOADER_EXPORT___;
